import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class GenericNameService extends ConfigurationService {

    public modelPath = 'pharmacy/generics';

    getDTColumns () {
        const self = this;
        return [{
            name: 'generic_id',
            title: 'Generic Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'generic_id'
        }, {
            name: 'generic_name',
            title: 'Generic Name',
            data: 'generic_name'
        }, {
            name: 'drug_schedule_id',
            title: 'Drug Schedule Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'drug_schedule_id'
        }, {
            name: 'drug_schedule_name',
            title: 'Schedule of Drug',
            data: 'drug_schedule_name'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-generic-name')) {
                    return `<div class="custom-control custom-checkbox">
							<input class="custom-control-input" data-modelPk="checkbox_${full.generic_id}" id="checkbox_${full.generic_id}" type="checkbox" />
							<label class="custom-control-label" for="checkbox_${full.generic_id}"></label>
						</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-generic-name')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.generic_id}" class="btn btn-secondary"><i data-modelPk="${full.generic_id}" class="icon-pencil "></i></a>`;
                }
                return '';
            }
        }];
    }
}
